'use strict';
var SearchBoxController = /** @class */ (function () {
    function SearchBoxController() {
        this.sortOptions = ['Products', 'Content'];
        this.sortOption = null;
        this.sortListVisible = false;
        this.isSortPlaceholder = true;
        this.sortPlaceholder = "Products";
        this.sortSelected = "";
        this.sortProperty = "";
        this.select = function (item) {
            this.isSortPlaceholder = false;
            this.sortSelected = item;
            this.sortListVisible = false;
            this.display = item;
        };
        this.isSelected = function (item) {
            return item[this.sortProperty] === this.sortSelected[this.sortProperty];
        };
        this.searchResults = function () {
            console.log("searching results");
        };
    }
    return SearchBoxController;
}());
export default SearchBoxController;
//# sourceMappingURL=search-box.controller.js.map